import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { Deposito } from './depositos.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepositosService {
  url: string;
  endpoint = 'depositos';

  constructor(private http: HttpClient) {}

  getDepositos(): Observable<Deposito[]> {
    return this.http.get<Deposito[]>(`${this.url}/${this.endpoint}/`);
  }

  addDepositos(depositos: Deposito[]): Observable<Deposito[]> {
    return this.http.post<Deposito[]>(`${this.url}/${this.endpoint}/`, {
      depositos
    });
  }

  deleteDepositos(depositos: Deposito): Observable<Deposito> {
    return this.http.delete<Deposito>(
      `${environment.apiUrl}/${this.endpoint}/${depositos.id}/`
    );
  }
}
